// Donation partner callout: confirm before leaving the site (snippets/donation-partner.liquid).
// The link keeps its href/target, so without JS (or without <dialog> support) it opens directly.
(function () {
  function init(link) {
    const dialog = document.getElementById(link.dataset.donationLink);
    if (!dialog || typeof dialog.showModal !== 'function' || link.dataset.donationBound) return;
    link.dataset.donationBound = 'true';

    const cancel = dialog.querySelector('[data-donation-cancel]');
    const proceed = dialog.querySelector('[data-donation-continue]');

    link.addEventListener('click', (event) => {
      event.preventDefault();
      dialog.showModal();
    });

    if (cancel) cancel.addEventListener('click', () => dialog.close());

    // Let the anchor open the new tab, then close the dialog.
    if (proceed) proceed.addEventListener('click', () => dialog.close());

    // Clicks on the backdrop target the <dialog> itself; content sits in an inner wrapper.
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    // Fires for Esc, Cancel, Continue and backdrop clicks.
    dialog.addEventListener('close', () => link.focus());
  }

  function initAll() {
    document.querySelectorAll('[data-donation-link]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
